// OrderRow (active order list item) + PastRow (delivered/completed list item).
// Both pull layout data from the orders/constants helpers.

import { C } from "../../lib/theme";
import { Card } from "../../components/Card";
import { Btn } from "../../components/Btn";
import { gradientForId } from "../../lib/gradients";
import { fmtK } from "../../lib/money";
import { STATUS_MAP, TONE, fmtWhen, firstItemTitle, firstItemImage } from "./constants";

export function OrderRow({ o, selected, onSelect }) {
  const [g1, g2] = gradientForId(o.id);
  const map = STATUS_MAP[o.status] || STATUS_MAP.pending_payment;
  const tone = TONE[map.tone];
  const img = firstItemImage(o);

  return (
    <button onClick={onSelect} style={{ all: "unset", cursor: "pointer", display: "block" }}>
      <Card
        pad={14}
        style={{
          borderColor: selected ? C.hunter : "rgba(196,193,183,0.25)",
          borderWidth: selected ? 2 : 1,
          background: selected ? C.cream : C.white,
        }}
      >
        <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
          <div
            style={{
              width: 60,
              height: 60,
              borderRadius: 12,
              background: img ? `url(${img}) center/cover` : `linear-gradient(135deg, ${g1}, ${g2})`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 28,
              flexShrink: 0,
              color: C.white,
            }}
          >
            {!img && "📦"}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 3 }}>
              <span className="mono" style={{ fontSize: 10.5, color: C.muted, fontWeight: 700 }}>
                {o.orders?.order_number || o.id.slice(0, 8)}
              </span>
              <span
                style={{
                  padding: "2px 7px",
                  borderRadius: 5,
                  background: tone.bg,
                  color: tone.fg,
                  fontSize: 10,
                  fontWeight: 800,
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                }}
              >
                {map.label}
              </span>
            </div>
            <div style={{ fontSize: 14, fontWeight: 800 }}>{firstItemTitle(o)}</div>
            <div style={{ fontSize: 11.5, color: C.muted, marginTop: 2 }}>
              {o.sellers?.store_name || "Seller"} · {fmtWhen(o.created_at)}
            </div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 15, fontWeight: 900, color: C.hunter }}>{fmtK(o.total)}</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 4, marginTop: 12 }}>
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              style={{ flex: 1, height: 4, borderRadius: 2, background: i < map.progress ? C.hunter : C.dustDk }}
            />
          ))}
        </div>
      </Card>
    </button>
  );
}

export function PastRow({ o, onSelect }) {
  const [g1, g2] = gradientForId(o.id);
  const img = firstItemImage(o);
  return (
    <Card pad={12}>
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: 10,
            background: img ? `url(${img}) center/cover` : `linear-gradient(135deg, ${g1}, ${g2})`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 20,
            opacity: 0.85,
            color: C.white,
          }}
        >
          {!img && "📦"}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, fontWeight: 800 }}>{firstItemTitle(o)}</div>
          <div style={{ fontSize: 11, color: C.muted }}>
            {o.sellers?.store_name || "Seller"} · {fmtWhen(o.delivered_at || o.created_at)}
          </div>
        </div>
        <div style={{ fontSize: 13, fontWeight: 800, color: C.muted }}>{fmtK(o.total)}</div>
        <Btn kind="outline" size="sm" icon="rotate-ccw" onClick={onSelect}>
          Details
        </Btn>
      </div>
    </Card>
  );
}
